<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Termék leadások</span>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativeDrop/fetchAll"
      />
    </div>
    <representative-drop-list />
    <template v-if="$route.meta.showUpdateRepresentativeDropDialog">
      <representative-drop-dialog
        :representative-drop-id="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import RepresentativeDropList from '../../components/representativeProcesses/representativeDrops/List';
  import TableFilter from '../../components/TableFilter';
  import RepresentativeDropDialog from '../../components/representativeProcesses/representativeDrops/Dialog'
  export default {
    components: {
      RepresentativeDropList,
      TableFilter,
      RepresentativeDropDialog,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let storages = this.$store.getters['storage/storages'];
        let users = this.$store.getters['user/users'];
        let ownCompanies = this.$store.getters['ownCompany/ownCompanies'];
        let currencies = this.$store.getters['currency/currencies'];
        if (!storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/storages'];
        }
        if(!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        if(!ownCompanies.length) {
          await this.$store.dispatch('ownCompany/fetchAll');
          ownCompanies = this.$store.getters['ownCompany/ownCompanies'];
        }
        if(!currencies.length) {
          await this.$store.dispatch('currency/fetchAll');
          currencies = this.$store.getters['currency/currencies'];
        }
        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
          {
            type: 'text',
            name: 'cm_delivery_note_number',
            label: 'CM szlev száma',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Átvéve',
                status: 'done'
              },
              {
                label: 'Átvételre vár',
                status: 'dropped'
              },
              {
                label: 'Visszamondva',
                status: 'cancelled'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            options: users,
            name: 'creator_user_id',
            label: 'Rögzítette',
            labelCallback: user => user.last_name + ' ' + user.first_name,
            valueKey: 'id',
          },
          {
            type: 'select',
            options: users,
            name: 'supplier_id',
            label: 'Leadó',
            labelCallback: user => user.last_name + ' ' + user.first_name,
            valueKey: 'id',
          },
          {
            type: 'select',
            options: storages,
            name: 'source_storage_id',
            label: 'Szállító raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
          },
        ];
      },
    },
  };
</script>
